<template>
  <section class="left-container">
      <Title name="规则目录"></Title>
      <div class="left-content clearfix">
        <div class="mrg-btm-15 clearfix">
          <div class="menu-list-wrap" v-for="(item, index) in navList" :key="`1-${index}`">
            <dl>
              <dt><router-link :to="{'name': 'Rule', 'query': {'categoryId': item.categoryId}}">{{item.name}}</router-link></dt>
              <dd v-for="(item2, index2) in item.children" :key="`2-${index2}`">
                <router-link :to="{'name': 'Rule', 'query': {'categoryId': item.categoryId, 'childCategoryId': item2.categoryId}}">{{item2.name}}</router-link>
              </dd>
            </dl>
          </div>
        </div>
      </div>

  </section>
</template>

<script>
import Title from './title.vue'
import { mapActions, mapState } from 'vuex'
export default {
  name: '',
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      navList: 'leftNavList'
    })
  },
  mounted () {
    this.getLeftNavList()
  },
  methods: {
    ...mapActions({
      getLeftNavList: 'getLeftNavList'
    })
  },
  components: {
    Title
  }
}
</script>

<style lang="scss" scoped>
.left-container {
  background: #fff;
  float: left;
  width: 412px;
  padding-left: 30px;
  padding-right: 18px;
  box-sizing: border-box;
  // position: absolute;
  // overflow: auto;
  height: 100%;
  padding-bottom: 9999px;
  margin-bottom: -9999px;
  .left-content {
    > div {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      .menu-list-wrap {
        flex: 0 0 50%;
      }
    }
    dl {
      padding-top: 12px;
      padding-left: 12px;
      margin-right: 8px;
      margin-bottom: 15px;
      background-image: linear-gradient(180deg, #FFF6F7 0%, rgba(255,255,255,0.00) 100%);
      border-radius: 6px;
      &:nth-child(3n) {
        margin-right: 0px;
      }
      dt {
        font-family: \5FAE\8F6F\96C5\9ED1,sans-serif;
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        line-height: 22px;
      }
      dd{
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        line-height: 20px;
        margin-top: 10px;
      }
    }
  }
}
</style>
